module.exports = __webpack_public_path__ + "img/adds.1c2ee8d5.svg";